<template>
	<div>
		<div class="flex">
			<h1
				class="mb-6 text-6xl"
				style="font-size: 3.375rem !important"
				v-if="loaded && ship"
			>
				{{ ship.base.name ? ship.base.name : selected_ship.label }}
			</h1>
			<div class="ml-auto -mt-2">
				<small class="">Select ship:</small>
				<div class="relative inline-block w-full text-gray-700">
					<select v-model="selectedShip" class="w-full h-10 pl-3 pr-6 text-base placeholder-gray-600 rounded-lg appearance-none focus:shadow-outline" 
						style="border: 1px solid rgba(60, 60, 60, 0.26)">
						<option
							v-for="(ship, idx) in ships"
							:key="idx"
							:value="idx"
						>
							{{ ship.base.name }}
						</option>
					</select>
					<div class="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
						<svg class="w-4 h-4 fill-current" viewBox="0 0 20 20"><path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
					</div>
				</div>
			</div>
		</div>

		<div class="grid grid-flow-row grid-cols-5 gap-6" v-if="loaded">
			<!-- Overall scoring / First column -->

			<ship-review-overall :ship="ship" />

			<!-- Trend analysis / Second and third column -->
			<ship-review-trend-analysis :ship="ship" />
		</div>
	</div>
</template>
        
<script>
import Vue from "vue";
import vSelect from "vue-select";
import ShipReviewOverall from "@/components/cat/ShipReviewOverall.vue";
import ShipReviewTrendAnalysis from "@/components/cat/ShipReviewTrendAnalysis.vue";

export default {
	data() {
		return {
			loaded: false,
			ship: {},
			ships: Vue.observable([]),
			json: null,
			selectedShip:0,
		};
	},
	components: {
		ShipReviewOverall,
		ShipReviewTrendAnalysis,
	},
	created() {
		this.fetchShipData();
	},
	watch: {
		selectedShip: {
			handler: function(idx) {
				this.ship = this.ships[idx];
			},
			immediate: false
		}
	},
	methods: {
		async fetchShipData() {
			// const spreadsheetId = "11elyp7YRy0E3W05pnIwX_9Vz9S1_qLo3yi2f25O9ZBE"; // test sheet
			const spreadsheetId = "1jk0I2MKYSolsmjYnAVlmIjBnW-oJCI-LEEHuSIowhr0"; // 2021_07_07_Crowd...
			let resp = await fetch(
					`https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:json&headers=1`
				),
				text = await resp.text();
			this.json = JSON.parse(text.substr(47).slice(0, -2));
			this.parseShipData();
			this.parseShipsData();
			this.loaded = true;
		},
		parseShipData() {
			let that = this;
			this.json.table.rows.forEach(function (row, idx) {
				if (!row.c) {
					return;
				}
				let c = row.c,
					cols = [c[2], c[3], c[4]],
					allNotNull = cols.reduce(
						(prev, cur) => prev && cur != null && cur.v != null,
						true
					);
				if (!allNotNull) {
					return;
				}

				let group = cols[0].v,
					key = cols[1].v,
					val = cols[2].v;

				//console.log(cols, group, key, val);

				if (!that.ship[group]) {
					that.ship[group] = {};
				}
				that.ship[group][key] = val;
			});
		},
		parseShipsData() {
			let that = this;
			// when the header row is non-empty after E (idx = 2)
			[0, 1].forEach(function (shipId) {
				that.json.table.rows.forEach(function (row, idx) {
					if (!row.c) {
						return;
					}

					let c = row.c,
						v = [c[2], c[3], c[4 + shipId]];

					if (v.includes(null)) {
						// this row is not complete, so skip it
						return;
					}

					let [group, key, val] = [v[0].v, v[1].v, v[2].v];

					//console.log(c, v, group, key, val);

					if (that.ships[shipId] == null) {
						that.ships[shipId] = {};
					}
					if (that.ships[shipId][group] == null) {
						that.ships[shipId][group] = {};
					}
					that.ships[shipId][group][key] = val;
				});
			});
		},
	},
};
</script>

<style scoped>

	body .vx-card {
		border-radius: 1rem;
	}

</style>